'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; desc = parent = getter = undefined; _again = false; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactStyle = require('react-style');

var _reactStyle2 = _interopRequireDefault(_reactStyle);

var _style = require('./style');

var _ = require('./');

var _utils = require('./utils');

var ButtonStyles = _reactStyle2['default'].create({
  normalButtonStyle: {
    WebkitTapHighlightColor: 'rgba(0,0,0,0)',
    cursor: 'pointer',
    position: 'relative',
    height: _style.Sizes.Button.height - 2 * 9,
    borderRadius: 3,
    display: 'inline-block',
    outline: 'none',
    padding: 9,
    textAlign: 'center',
    userSelect: 'none',
    minWidth: _style.Sizes.Button.minWidth,
    lineHeight: '19px'
  },

  raisedButtonStyle: {
    backgroundColor: _style.Colors.grey.P300
  },

  raisedButtonPressedStyle: {
    boxShadow: '0 8px 17px 0 rgba(0, 0, 0, 0.2)'
  },

  disabledButtonStyle: {
    backgroundColor: _style.Colors.grey.P300,
    color: _style.Colors.grey.P500,
    cursor: 'default'
  },

  shadowStyle: {
    borderRadius: '3px'
  },

  rippleContainerStyle: {
    overflow: 'hidden',
    borderRadius: '3px'
  }
});

var _default = (function (_React$Component) {
  var _class = function _default(props) {
    _classCallCheck(this, _class);

    _get(Object.getPrototypeOf(_class.prototype), 'constructor', this).call(this, props);
    this.state = {
      active: false
    };
  };

  _inherits(_class, _React$Component);

  _createClass(_class, [{
    key: 'onMouseUp',
    value: function onMouseUp() {
      if (this.props.disabled) {
        return;
      }
      this.setState({ active: false });
    }
  }, {
    key: 'onMouseDown',
    value: function onMouseDown() {
      if (this.props.disabled) {
        return;
      }
      this.setState({ active: true });
    }
  }, {
    key: 'renderRipples',
    value: function renderRipples(disabled, onClick, styles) {
      if (disabled) {
        return null;
      }
      return _react2['default'].createElement(_.RippleContainer, {
        onClick: onClick,
        styles: styles });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this = this;

      var shadowStyle = ButtonStyles.shadowStyle;
      var rippleContainerStyle = ButtonStyles.rippleContainerStyle;
      var normalButtonStyle = ButtonStyles.normalButtonStyle;
      var _props = this.props;
      var children = _props.children;
      var disabled = _props.disabled;
      var onClick = _props.onClick;
      var raised = _props.raised;

      var styles = [_style.Typography.button, normalButtonStyle];

      var shadowSize = -1;
      if (this.props.styles) {
        styles = styles.concat(this.props.styles);
      }
      if (disabled) {
        styles.push(ButtonStyles.disabledButtonStyle);
      } else if (raised) {
        styles.push(ButtonStyles.raisedButtonStyle);
        shadowSize = 1;

        if (this.state.active) {
          shadowSize = 2;
        }
      }

      return _react2['default'].createElement(
        'div',
        {
          onMouseDown: function () {
            return !_utils.isTouchDevice && _this.onMouseDown();
          },
          onMouseLeave: function () {
            return !_utils.isTouchDevice && _this.onMouseUp();
          },
          onMouseUp: function () {
            return !_utils.isTouchDevice && _this.onMouseUp();
          },
          onTouchCancel: function () {
            return _utils.isTouchDevice && _this.onMouseUp();
          },
          onTouchEnd: function () {
            return _utils.isTouchDevice && _this.onMouseUp();
          },
          onTouchStart: function () {
            return _utils.isTouchDevice && _this.onMouseDown();
          },
          role: 'button',
          styles: styles,
          tabIndex: '0' },
        _react2['default'].createElement(
          _.Shadow,
          { size: shadowSize, styles: shadowStyle },
          this.renderRipples(disabled, onClick, rippleContainerStyle),
          children
        )
      );
    }
  }], [{
    key: 'displayName',
    value: 'Button',
    enumerable: true
  }, {
    key: 'defaultProps',
    value: {
      onClick: _utils.noop
    },
    enumerable: true
  }, {
    key: 'propTypes',
    value: {
      children: _react.PropTypes.node,
      disabled: _react.PropTypes.bool,
      onClick: _react.PropTypes.func,
      styles: _react.PropTypes.array,
      raised: _react.PropTypes.bool
    },
    enumerable: true
  }]);

  return _class;
})(_react2['default'].Component);

exports['default'] = _default;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-material/lib/Button.js
 ** module id = 187
 ** module chunks = 0
 **/